import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Result } from 'antd'

/** react-router 路由级错误页（loader/action/渲染抛错） */
export default function RouteErrorPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const error = useRouteError()

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : undefined

  return (
    <div className="flex min-h-full min-h-[100vh] items-center justify-center bg-[var(--page)] p-6">
      <Result
        className="max-w-[480px]"
        status="error"
        title={t('errorBoundary.title')}
        subTitle={
          <span className="block truncate">
            {detail ? `${t('errorBoundary.desc')} (${detail})` : t('errorBoundary.desc')}
          </span>
        }
        extra={
          <Button type="primary" onClick={() => navigate('/apps', { replace: true })}>
            {t('errorBoundary.retry')}
          </Button>
        }
      />
    </div>
  )
}
